import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PrecioSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-12" data-id="element-130">
          <div className="inline-block bg-brand-black text-brand-orange font-bold px-4 py-1.5 rounded-full text-sm uppercase tracking-wider mb-6 animate-pulse-subtle" data-id="element-131">
            Solo durante marzo
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6" data-id="element-132">
            Accedé hoy con pago único
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-133">
            A partir de abril, el programa pasa a ser una membresía mensual. Si
            entrás ahora, te llevás el acceso de por vida.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.1
      }} className="bg-white rounded-3xl overflow-hidden border-2 border-brand-orange shadow-2xl relative" data-id="element-134">
          <div className="bg-brand-orange text-brand-black text-center py-3 font-bold uppercase tracking-widest text-sm" data-id="element-135">
            Oferta fundadores
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-136">
            <div className="flex justify-center items-center gap-4 mb-4" data-id="element-137">
              <span className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-138">
                Membresía mensual
              </span>
            </div>

            <div className="mb-8" data-id="element-139">
              <h3 className="text-5xl md:text-6xl font-heading font-extrabold text-brand-black mb-2" data-id="element-140">
                Pago único
              </h3>
              <p className="text-brand-orange font-bold text-xl" data-id="element-141">
                Acceso de por vida
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left max-w-md mx-auto" data-id="element-142">
              <p className="font-bold text-brand-black mb-4 text-center" data-id="element-143">
                Si entrás ahora, evitás pagar todos los meses y te llevás:
              </p>
              <ul className="space-y-3" data-id="element-144">
                {['Sistema completo paso a paso', 'Clases pregrabadas', 'Reuniones semanales en vivo', 'Comunidad privada', 'Actualizaciones futuras gratis'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-145">
                    <Check className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-146" />
                    <span className="text-gray-700 font-medium" data-id="element-147">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-148">
              <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-5 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center animate-pulse-subtle" data-id="element-149">
                Ingresar ahora (pago único)
              </a>
            </div>

            <div className="mt-6" data-id="element-150">
              <a href="https://wa.me/5491100000000" className="text-gray-500 font-medium hover:text-brand-black transition-colors underline underline-offset-4" data-id="element-151">
                Consultar por WhatsApp antes de entrar
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}